export const capitalize = (str) => (str ? str.trim().replace(/^\w/, (c) => c.toUpperCase()) : '');
export const joinUnderscore = (strArray) => (strArray ? strArray.split(' ').join('_').toLowerCase() : '');
